import { toApiError } from '@/shared/api';
import { problemText } from '@/shared/api/problemText';

const NO_ANSWER = new Set([0, 502, 503, 504]);

export const CLEANING_PROBLEMS: Record<string, string> = {
  // Der Server meldet „schon übernommen oder nicht mehr offen“ – wer es war, sagt er nicht.
  cleaning_task_already_claimed: 'Die Aufgabe ist nicht mehr frei.',
  already_completed: 'Die Aufgabe ist schon erledigt.',
  task_cancelled: 'Die Buchung dahinter gibt es nicht mehr.',
  cleaning_task_terminal: 'Die Aufgabe ist schon abgeschlossen oder entfällt.',
  cleaning_photo_slots_require_auto_complete:
    'Diese Aufgabe verlangt Fotos; mit dem letzten Foto ist sie erledigt.',
  invalid_status_transition: 'Die Aufgabe hat inzwischen einen anderen Stand.',
  cleaning_task_status_conflict: 'Die Aufgabe hat inzwischen einen anderen Stand.',
  cleaning_task_start_conflict: 'Die Aufgabe hat inzwischen einen anderen Stand.',
  cleaning_task_not_found: 'Die Aufgabe gibt es nicht mehr.',
  cleaning_photo_not_found: 'Das Foto gibt es nicht mehr.',
  cleaning_task_not_owned: 'Die Aufgabe gehört jemand anderem.',
  cleaning_claim_forbidden: 'Dein Zugang erlaubt das Übernehmen nicht.',
  cleaning_work_forbidden: 'Dein Zugang erlaubt das nicht.',
  cleaning_assignment_forbidden: 'Dein Zugang erlaubt das Zuteilen nicht.',
  assignee_not_assignable:
    'Diese Person kann die Aufgabe nicht übernehmen: kein Zugriff aufs Apartment, deaktiviert oder ohne Reinigungsrolle.',
  cleaning_task_assignment_conflict: 'Die Aufgabe hat sich beim Zuweisen geändert.',
  property_not_found: 'Das Apartment gibt es in diesem Workspace nicht.',
};

/** Ohne Antwort ist offen, ob es gewirkt hat — der Satz sagt das, der Stand lädt ohnehin neu. */
export const NO_ANSWER_TEXT =
  'Keine Antwort vom Server – ob es geklappt hat, zeigt der neu geladene Stand.';

/** Deutscher Satz zu einem gescheiterten Reinigungsschritt; `unknown`, wenn offen ist, ob er wirkte. */
export async function cleaningFailure(
  error: unknown,
  fallback: string,
): Promise<{ text: string; unknown: boolean }> {
  const problem = await toApiError(error);
  if (NO_ANSWER.has(problem.status)) return { text: NO_ANSWER_TEXT, unknown: true };
  return {
    text: problemText(problem, fallback, { known: CLEANING_PROBLEMS }),
    unknown: false,
  };
}
